// Index file for the directory. Don't add anything else here.
import CarouselTransactionProcess from './CarouselTransactionProcess';
export default CarouselTransactionProcess;
